module.exports = __webpack_public_path__ + "img/sector_scale.6f153a3d.svg";